import React from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/SearchOutlined";
import ClearIcon from "@material-ui/icons/Clear";

interface IProps {
  toolbarProps: any;
}
export default function TableSearch(props: IProps) {
  const { toolbarProps } = props;
  return (
    <div className="table-toolbar">
      <div className="spacer" />
      <TextField
        variant="outlined"
        value={toolbarProps.searchText}
        onChange={event => {
          toolbarProps.onSearchChanged(event.target.value);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                disabled={!toolbarProps.searchText}
                onClick={() => toolbarProps.onSearchChanged?.("")}
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
        className="tableSearch"
      />
    </div>
  );
}
